<template src="./template.html"></template>
<style lang="scss" src="./styles.scss" scoped></style>

<script>
  import { mapState } from 'vuex'
  import GroupInvitationOverlay from '@/components/overlays/group/GroupInvitationOverlay'

  export default {
    name: 'GroupInvitations',
    components: {
      GroupInvitationOverlay,
    },
    props: {
      invitations: Array,
      title: String,
      type: String,
    },
    data() {
      return {
        selectedGroup: null,
      }
    },
    computed: {
      ...mapState('auth', ['settings']),
    },
    methods: {
      closeOverlay() {
        this.selectedGroup = null
      },
      onAccept(id, type) {
        this.$emit('accept', id, type)
      },
      onDecline(id, type) {
        this.$emit('decline', id, type)
      },
    },
  }
</script>
